import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { VlbLookupResponse } from '@/types/bestellung';

// useMutation statt useQuery: Der VLB-Lookup wird ausgeloest, nicht
// abonniert. Seit A17 loest ihn auch die Automatik aus, sobald die ISBN im
// Feld vollstaendig und gueltig ist — das bleibt ein Ausloesen zu einem
// bestimmten Zeitpunkt und kein reaktives Nachfuehren bei jedem Zeichen.
// (Der Satz stand hier frueher als "auf Knopfdruck ... nicht reaktiv beim
// Tippen"; das war bis A17 dasselbe und ist es seitdem nicht mehr.)
// Mutation passt zum Aufruf-Modell, auch wenn es technisch ein GET ist.
export function useVlbLookup() {
  return useMutation({
    mutationFn: (isbn: string) =>
      apiFetch<VlbLookupResponse>(`/vlb/lookup.php?isbn=${encodeURIComponent(isbn)}`)
  });
}
